import Swal from 'sweetalert2'

export const ResponseUtils = {

  getErrorData: error => {
    if (error && error.response && error.response.data) {
      return error.response.data
    }
  },

  handleError: (error, loader) => {
    let message = 'Ocorreu um erro inesperado, por favor entre em contato com o administrador do sistema.'
    if (error.response && error.response.data && error.response.data.mensagem) {
      message = error.response.data.mensagem
    }

    if (loader) {
      loader.hide()
    }

    Swal.fire({
      icon: 'error',
      text: message
    })
  }

}

export default ResponseUtils
